import type { Message } from '../../store/slices/chat/types';

export const parseSystemMessage = (text: string): string => {
  return text.replace(/<[^>]*>/g, '').trim();
};

export const createMessage = (userId: string, input: string, tableId: string, casinoId: string): Message => ({
  content: input.trim(),
  action: 'COMMAND',
  messageId: `${userId}_${Date.now()}`,
  userId,
  tableId,
  casinoId,
  role: 'GAME_USER',
  tagMessage: 'GAME_USER',
  timestamp: Date.now(),
});

export const createFreshChatSubscriptionMessage = (userId: string, tableId: string, casinoId: string): Message => ({
  ...createMessage(userId, '', tableId, casinoId),
  isliveSupportChat: true,
});

export const createDealerWelcomeMessage = (
  tableName: string,
  hideDealerNameInWelcomeMessage: boolean,
  dealerName: string
): Message => ({
  messageId: 'dealer_welcome_message',
  role: 'GAME_USER',
  tagMessage: 'GAME_USER',
  content: `WELCOMETO ${tableName}`,
  userId: 'dealer',
  userScreenName: hideDealerNameInWelcomeMessage ? undefined : dealerName,
  requireTranslation: true,
  timestamp: Date.now(),
  showMessage: true,
});
